import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import { rootReducer } from './reducers/root.reducer'
import thunk from 'redux-thunk'
const store = createStore(rootReducer, applyMiddleware(thunk))

export default store
